import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { getCities } from "../../services/api";
import logo1 from "../../assets/images/GlobalAcresLLPFinal.png";
import "./Footer.css";

const SITE_NAME = "JMJK Properties";
const CONTACT_EMAIL = "jmjkproperties@gmail.com";
const CONTACT_PHONE = "+91 000000000";

function citySlug(c) {
  return (
    c.slug ||
    String(c.name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-") ||
    c.id
  );
}

export default function Footer() {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    getCities()
      .then((list) => setCities(Array.isArray(list) ? list : []))
      .catch(() => setCities([]));
  }, []);

  const cityNames = cities.map((c) => c.name).filter(Boolean);
  const locationLine =
    cityNames.length > 0
      ? cityNames.slice(0, 3).join(" · ")
      : "Mumbai · Delhi · Bangalore";

  return (
    <footer className="footer-modern">
      <div className="footer-main">
        <div className="footer-brand">
          <div >
            <img src={logo1} alt={SITE_NAME} className="footer-logo" />
          </div>
          <p className="footer-tagline">
            Curated premium properties across India's top cities. Handpicked
            developers, transparent pricing.
          </p>
        </div>

        <div>
          <h4 className="footer-title">Explore</h4>
          <ul className="footer-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/projects/residential">Residential</Link>
            </li>
            <li>
              <Link to="/projects/commercial">Commercial</Link>
            </li>
            <li>
              <Link to="/projects/plots">Plots</Link>
            </li>
            <li>
              <Link to="/about">Who We Are</Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="footer-title">Cities</h4>
          <ul className="footer-list">
            {cities.length === 0 && <li>Loading…</li>}
            {cities.map((c) => (
              <li key={c.id || c.name}>
                <Link to={`/city/${citySlug(c)}`}>{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="footer-title">Contact</h4>
          <ul className="footer-list footer-contact">
            <li>
              <Mail className="footer-icon" />
              <span>{CONTACT_EMAIL}</span>
            </li>
            <li>
              <Phone className="footer-icon" />
              <span>{CONTACT_PHONE}</span>
            </li>
            <li>
              <MapPin className="footer-icon" />
              <span>{locationLine}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span>
            © {new Date().getFullYear()} {SITE_NAME}. All rights reserved.
          </span>
          <span>Made with care for premium homeseekers.</span>
        </div>
      </div>
    </footer>
  );
}